import { useEffect, useState } from "react";

export function useActiveSection(ids) {
  const [active, setActive] = useState("");

  useEffect(() => {
    const visible = new Map();
    const observers = [];

    const pick = () => {
      let current = "";
      for (const id of ids) {
        if (visible.get(id)) current = id;
      }
      setActive(current);
    };

    ids.forEach((id) => {
      const el = document.getElementById(id);
      if (!el) return;
      const observer = new IntersectionObserver(
        ([entry]) => {
          visible.set(id, entry.isIntersecting);
          pick();
        },
        { rootMargin: "-35% 0px -60% 0px" }
      );
      observer.observe(el);
      observers.push(observer);
    });

    return () => observers.forEach((o) => o.disconnect());
  }, [ids]);

  return active;
}
